<template>
  <div>
    <div v-if="meta.total > 0 || !meta.keyword">
      <div class="weekly-best" v-if="weeklyChampion && weeklyChampion.hasOwnProperty('isChecked')">
        <div class="bg-img" :style="{ backgroundImage: `url(${weeklyChampion.picUrl})` }"></div>
        <div class="cover"></div>
        <div class="container">
          <img :src="weeklyChampion.picUrl" alt="" />
          <div class="desc">
            <p class="title">本周人气最佳</p>
            <p class="name">
              <span>{{ weeklyChampion.author }}</span>&nbsp;
              <span>{{ weeklyChampion.worksname }}</span>
            </p>
            <p class="intro">{{ weeklyChampion.worksIntroduce }}</p>
            <div class="vote-info">
              <el-checkbox class="vote-check" v-model="isChecked" @change="voteChangeEvent($event, weeklyChampion)">{{
                  weeklyChampion.id | fillZero
              }}</el-checkbox>
              <div class="vote-num">
                <svg t="1648779091692" class="icon vote-icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="13584" width="200" height="200">
                  <path
                    d="M598.354747 67.542626c-48.148687 0-90.130101 32.905051-98.960808 79.437576 0 0-14.312727 72.882424-21.798787 99.090101-12.308687 43.196768-55.363232 90.944646-86.522829 106.188283-23.531313 11.636364-110.99798 11.765657-116.350707 11.765656H155.707475c-32.762828 0-59.384242 26.479192-59.384243 59.384243v475.022222c0 32.762828 26.479192 59.384242 59.384243 59.384242h548.033939c88.126061 0 163.025455-64.452525 176.135758-151.647676l45.873131-305.713132c10.834747-71.809293-44.8-136.274747-117.423838-136.274747H673.254141s20.066263-66.469495 30.228687-178.669899c5.081212-56.837172-35.167677-110.99798-94.280404-117.152323-3.620202-0.54303-7.227475-0.814545-10.847677-0.814546zM333.705051 898.288485V421.533737c38.917172-2.534141 66.999596-8.016162 83.574949-16.316767 43.726869-21.669495 99.633131-81.040808 117.281616-143.088485 7.899798-27.681616 21.39798-96.155152 23.001212-104.184243 3.47798-17.92 20.596364-31.159596 40.649697-31.159596 1.603232 0 3.206465 0.129293 4.822627 0.271516 28.211717 2.947879 43.326061 29.698586 41.32202 52.686868-9.360808 103.912727-27.823838 166.503434-28.082425 166.904243l-23.130505 76.489697h215.182223c17.519192 0 33.564444 7.356768 45.071515 20.596363 11.507071 13.239596 16.316768 30.228687 13.640404 47.618586L821.294545 797.052121c-8.830707 58.569697-58.181818 101.094141-117.423838 101.094142h-370.165656v0.142222z m-177.997576 0v-475.022222h118.626262v475.022222H155.707475z m0 0"
                    p-id="13585"></path>
                </svg><span>{{ weeklyChampion.weekVoteNumber || 0 }}</span>
              </div>
              <div class="vote-look">
                <svg t="1648779066842" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="12773" width="200" height="200">
                  <path
                    d="M919.5 491.5c-2.1-2.4-52.3-60.5-126.5-119.2-44-34.8-87.4-62.7-129-82.8-53.7-26-104.9-39.1-152.1-39.1-47.2 0-98.3 13.1-152 39-41.6 20-84.9 47.8-128.9 82.5-74.1 58.5-124.2 116.3-126.3 118.8-10.3 11.9-10.4 29.6-0.1 41.6 2.1 2.4 51.8 60.6 125.8 119.4 43.9 34.9 87.2 62.8 128.9 82.9 53.8 26 105.2 39.2 152.7 39.2 47.5 0 98.9-13.1 152.7-39 41.7-20 85.1-47.8 129-82.6 74-58.6 123.8-116.5 125.9-119 10.2-12 10.2-29.7-0.1-41.7z m-87.4 41c-20.3 20.1-47.5 45.2-79.1 70.2-112 88.4-192.9 107-241 107-48.1 0-128.9-18.6-240.9-107.4-31.6-25.1-58.8-50.4-79.1-70.5-11.1-11.1-11.1-29.1 0.1-40.1 20.2-19.8 47.2-44.7 78.6-69.6 112.7-89 193.4-107.7 241.3-107.7 68.3 0 151.5 37.1 240.5 107.4 31.8 25.1 59.2 50.4 79.6 70.6 11.2 11 11.2 29 0 40.1z"
                    p-id="12774"></path>
                  <path
                    d="M511.2 363.5c-82 0-148.8 66.7-148.8 148.8 0 82 66.7 148.8 148.8 148.8 82 0 148.8-66.7 148.8-148.8-0.1-82.1-66.8-148.8-148.8-148.8z m0 233.5c-46.7 0-84.8-38-84.8-84.8s38-84.8 84.8-84.8 84.8 38 84.8 84.8-38.1 84.8-84.8 84.8z"
                    p-id="12775"></path>
                </svg><span>{{ weeklyChampion.pageViewNumber || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!voteIntroShow" class="content-wrap works-list">
        <div class="item-wrap1" v-for="item in imgList" :key="item.picId" :style="{ width: `${item.width}px` }">
          <div class="item" @click="$router.push(`/works/${$route.params.type}/${item.id}`)" :style="{
            background: $store.state.env.isIE
              ? item.recommend === '500px'
                ? `url(${item.picUrl}) no-repeat center`
                : `url(${item.picUrl}?x-oss-process=image/resize,p_10,w_${item.width}) no-repeat center`
              : '',
            backgroundSize: $store.state.env.isIE ? `cover` : '',
          }">
            <img v-if="!$store.state.env.isIE" :src="
              item.recommend === '500px'
                ? item.picUrl
                : `${item.picUrl}?x-oss-process=image/resize,p_10,w_${item.width}`
            " :alt="item.worksname" />
            <div class="mask">
              <div class="info">
                <h2>{{ item.worksname }}</h2>
                <h3>{{ item.author }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="content-wrap works-list">
        <div class="item-wrap2" v-for="item in imgList" :key="item.picId">
          <div class="item" @click="$router.push(`/works/${$route.params.type}/${item.id}`)" :style="{
            background: $store.state.env.isIE
              ? item.recommend === '500px'
                ? `url(${item.picUrl}) no-repeat center`
                : `url(${item.picUrl}?x-oss-process=image/resize,p_10) no-repeat center`
              : '',
            backgroundSize: $store.state.env.isIE ? `cover` : '',
          }">
            <img v-if="!$store.state.env.isIE" :src="
              item.recommend === '500px'
                ? `${item.picUrl}`
                : `${item.picUrl}?x-oss-process=image/resize,p_10`
            " :alt="item.worksname" />
            <div class="mask">
              <div class="info">
                <h2>{{ item.worksname }}</h2>
                <h3>{{ item.author }}</h3>
              </div>
            </div>
          </div>
          <div class="vote-info">
            <el-checkbox class="vote-check" v-model="item.isChecked" @change="voteChangeEvent($event, item)">{{ item.id
                | fillZero
            }}</el-checkbox>
            <div class="vote-num">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-dianzan"></use>
              </svg><span>{{ item.weekVoteNumber || 0 }}</span>
            </div>
            <div class="vote-look">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-views"></use>
              </svg><span>{{ item.pageViewNumber || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <el-pagination layout="prev, pager, next" :total="meta.total" :page-size="meta.pageSize"
          :current-page="Number(meta.currentPage)" @current-change="currentChangeEvent">
        </el-pagination>
      </div>
    </div>
    <div v-else class="search-fail">
      <div>没有找到你想要的作品, 猜测你想找的是它</div>
      <div v-if="guessData.length > 0 && !voteIntroShow" class="guess-item1"
        @click="$router.push(`/works/${$route.params.type}/${guessData[0].id}`)" :style="{
          background: $store.state.env.isIE
            ? guessData[0].recommend === '500px'
              ? `${guessData[0].picUrl}`
              : `url(${guessData[0].picUrl}?x-oss-process=image/resize,p_10,w_${guessData[0].width}) no-repeat center`
            : '',
          backgroundSize: $store.state.env.isIE ? `cover` : '',
          width: `${guessData[0].width}px`,
        }">
        <img v-if="!$store.state.env.isIE" :src="
          guessData[0].recommend === '500px'
            ? `${guessData[0].picUrl}`
            : `${guessData[0].picUrl}?x-oss-process=image/resize,p_10,w_${guessData[0].width}`
        " :alt="guessData[0].worksname" />
        <div class="mask">
          <div class="info">
            <h2>{{ guessData[0].worksname }}</h2>
            <h3>{{ guessData[0].author }}</h3>
          </div>
        </div>
      </div>
      <div v-if="guessData.length > 0 && voteIntroShow" class="guess-item2"
        @click="$router.push(`/works/${$route.params.type}/${guessData[0].id}`)" :style="{
          background: $store.state.env.isIE
            ? guessData[0].recommend === '500px'
              ? `${guessData[0].picUrl}`
              : `url(${guessData[0].picUrl}?x-oss-process=image/resize,p_10) no-repeat center`
            : '',
          backgroundSize: $store.state.env.isIE ? `cover` : '',
        }">
        <img v-if="!$store.state.env.isIE" :src="
          guessData[0].recommend === '500px'
            ? `${guessData[0].picUrl}`
            : `${guessData[0].picUrl}?x-oss-process=image/resize,p_10`
        " :alt="guessData[0].worksname" />
        <div class="mask">
          <div class="info">
            <h2>{{ guessData[0].worksname }}</h2>
            <h3>{{ guessData[0].author }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import worksApi from "@/api/works";

export default {
  name: "WorksListMain",
  data() {
    return {
      weeklyChampion: null,
      imgList: [],
      meta: {
        total: 0,
        pageSize: 20,
        currentPage: 1,
        keyword: "",
      },
      endNum: 0,
      guessData: [],
      picData: [],
      imgArr: [],
      voteIntroShow: true,
      isChecked: false,
    };
  },
  filters: {
    fillZero(num, length = 5) {
      for (var len = (num + "").length; len < length; len = num.length) {
        num = "0" + num;
      }
      return num;
    },
  },
  computed: {
    ...mapState(["sortActive", "selectedArr", "imgListNum", "searchWorksType"]),
  },
  watch: {
    async endNum(newVal) {
      if (newVal === this.imgListNum && this.imgListNum > 0) {
        let width = 0; //当前行的宽度(包括图片宽度和边距)
        let start = 0; // 当前行的起始索引
        this.imgArr.forEach((value, index) => {
          if (value.picType === "0") {
            width += 538;
          } else {
            width += 269;
          }
          if (width === 1614) {
            width = 0;
            start = index + 1;
          }
          if (width === 1883) {
            let sum = 0;
            for (let i = start; i <= index; i++) {
              if (this.imgArr[i].picType === "0") {
                sum += 2;
              } else {
                sum += 1;
              }
            }
            const averageWidth = Math.floor(
              (1614 - (index - start + 1) * 14) / sum
            );
            let width2 = 0;
            for (let i = start; i <= index; i++) {
              if (i < index) {
                if (this.imgArr[i].picType === "0") {
                  width2 += averageWidth * 2;
                  this.imgArr[i].width = averageWidth * 2;
                } else {
                  width2 += averageWidth;
                  this.imgArr[i].width = averageWidth;
                }
              } else {
                this.imgArr[i].width = 1614 - (index - start + 1) * 14 - width2;
              }
            }
            width = 0;
            start = index + 1;
          }
        });
        this.endNum = 0;
        this.imgArr.forEach((value) => this.imgList.push(value));
        if (this.picData.length > 0) {
          await worksApi.updatePicType(this.picData);
        }
        this.picData = [];
      }
    },
  },
  methods: {
    ...mapMutations(["setBreadcrumb", "setSelectedArr", "radioText"]),
    /**
     * 分页改变事件
     */
    currentChangeEvent(val) {
      let that = this
      this.meta.currentPage = val;
      this.$router.push({
        path: `/works/${that.$route.params.type}`,
        query: { currentPage: val, keyword: this.meta.keyword || "" },
      });
    },
    async weekChampion() {
      let type = this.$route.params.type
      let res = await worksApi.weekChampion(type);
      if (res.code === 200) {
        let flag = this.selectedArr.indexOf(res.id);
        if (res.data !== null) {
          this.weeklyChampion = Object.assign({}, res.data, {
            isChecked: flag > -1 ? true : false,
          });
        }
        console.log(this.weeklyChampion);
      }
    },
    /**
     * 获取数据
     */
    async fetchData(type = false) {
      let that = this
      if (type && this.meta.currentPage !== 1) {
        this.meta.currentPage = 1;
        this.$router.push({
          path: `/works/${that.$route.$route.params.type}`,
          query: {
            currentPage: this.meta.currentPage,
            keyword: this.meta.keyword || "",
          },
        });
        return;
      }
      this.weekChampion();
      let data = await worksApi.fetchWorksList({
        page: this.meta.currentPage,
        keyword: this.meta.keyword,
        sort: this.sortActive,
        type: this.searchWorksType,
        hodingTime: "2022",
      });
      this.imgArr.splice(0, this.imgArr.length);
      this.imgList.splice(0, this.imgList.length);
      if (data.code === 200) {
        // const tempArr = [];
        // data.data.forEach(v => tempArr.push({ ...v, picUrl: v.picUrl.replace("!p6", "!p5") }));
        // data.data = JSON.parse(JSON.stringify(tempArr));
        if (data.meta.searchIsNull === 1) {
          this.getGuessData(data);
        } else {
          if (!this.voteIntroShow) {
            const vm = this;
            this.$store.commit("setImgListNum", data.data.length);
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].picType === null) {
                let img = new Image();
                img.src =
                  data.data[i].recommend === "500px"
                    ? `https://images.weserv.nl/?url=${data.data[i].picUrl}&w=10&fit=inside`
                    : data.data[i].picUrl +
                    "?x-oss-process=image/resize,p_10,w_5";
                img.onload = function () {
                  let flag = vm.selectedArr.indexOf(data.data[i].id);
                  vm.imgArr.splice(i, 0, {
                    ...data.data[i],
                    picUrl:
                      data.data[i].recommend === "500px"
                        ? `https://images.weserv.nl/?url=${data.data[i].picUrl}&w=1200&fit=inside`
                        : data.data[i].picUrl,
                    picType: img.width >= img.height ? "0" : "1",
                    width: img.width >= img.height ? 524 : 255,
                    isChecked: flag > -1 ? true : false,
                  });
                  vm.picData.push({
                    picId: data.data[i].picId,
                    picType: img.width >= img.height ? "0" : "1",
                  });
                  vm.endNum++;
                };
              } else {
                let flag = this.selectedArr.indexOf(data.data[i].id);
                vm.imgArr.splice(i, 0, {
                  ...data.data[i],
                  picUrl:
                    data.data[i].recommend === "500px"
                      ? `https://images.weserv.nl/?url=${data.data[i].picUrl}&w=1200&fit=inside`
                      : data.data[i].picUrl,
                  width: data.data[i].picType === "0" ? 524 : 255,
                  isChecked: flag > -1 ? true : false,
                });
                vm.endNum++;
              }
            }
          } else {
            this.imgList = data.data.map((i) => {
              let flag = this.selectedArr.indexOf(i.id);
              return {
                ...i,
                picUrl:
                  i.recommend === "500px"
                    ? `https://images.weserv.nl/?url=${i.picUrl}&w=1200&fit=inside`
                    : i.picUrl,
                isChecked: flag > -1 ? true : false,
              };
            });
          }
          this.meta = {
            total: data.meta.total,
            pageSize: data.meta.limit,
            currentPage: data.meta.page,
            keyword: data.meta.name,
          };
        }
      }
    },

    /**
     * 猜测的作品
     */
    async getGuessData(guessData) {
      const vm = this;
      vm.guessData = [];
      vm.meta.total = 0;
      if (guessData.data && guessData.data.length > 0) {
        if (!this.voteIntroShow) {
          if (guessData.data[0].picType === null) {
            let img = new Image();
            img.src =
              guessData.data[0].recommend === "500px"
                ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=10&fit=inside`
                : guessData.data[0].picUrl +
                "?x-oss-process=image/resize,p_10,w_5";
            img.onload = function () {
              vm.guessData.push({
                ...guessData.data[0],
                picUrl:
                  guessData.data[0].recommend === "500px"
                    ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=1200&fit=inside`
                    : guessData.data[0].picUrl,
                picType: img.width >= img.height ? "0" : "1",
                width: img.width >= img.height ? 524 : 255,
              });
            };
          } else {
            vm.guessData.push({
              ...guessData.data[0],
              picUrl:
                guessData.data[0].recommend === "500px"
                  ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=1200&fit=inside`
                  : guessData.data[0].picUrl,
              width: guessData.data[0].picType === "0" ? 524 : 255,
            });
          }
        } else {
          vm.guessData.push({
            ...guessData.data[0],
            picUrl:
              guessData.data[0].recommend === "500px"
                ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=1200&fit=inside`
                : guessData.data[0].picUrl,
          });
        }
      }
    },

    /**
     * 选择作品
     */
    voteChangeEvent(status, obj) {
      console.log(obj);
      if (this.selectedArr.length >= 5 && status) {
        setTimeout(() => {
          obj.isChecked = false;
        }, 100);
        this.$message.warning("您已经选择5副作品啦！");
      } else {
        this.setSelectedArr({ status, value: obj.id });
      }
    },
    /**
     * 投票成功清空选择
     */
    clearSelectedFn() {
      this.imgList.forEach((item, index) => {
        if (item.isChecked) {
          item.isChecked = false;
          item.weekVoteNumber++; // 票数加1
        }
        if (this.isChecked) {
          this.isChecked = false;
        }
      });

      this.setSelectedArr([]);
    },
  },
  created() {
    this.meta = {
      keyword: this.$route.query.keyword || "",
      currentPage: this.$route.query.currentPage || 1,
    };
    this.radio = this.radioText[this.searchWorksType];
    this.fetchData();
    if (this.meta.keyword) {
      this.setBreadcrumb([
        // {
        //   title: "作品列表",
        //   url: "/works",
        // },
        // {
        //   title: `${this.meta.keyword} 的搜索结果`,
        // },
      ]);
    } else {
      // this.setBreadcrumb([
      //   {
      //     title: "作品列表",
      //   },
      // ]);
    }
  },
};
</script>
<style lang="scss" scoped>
.weekly-best {
  position: relative;
  margin: 55px 0;
  width: 1920px;
  height: 560px;
  transform: translateX(-155px);

  .cover {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    filter: blur(4px);
    z-index: 10;
  }

  .bg-img {
    width: 100%;
    height: 100%;
    background-size: cover;
    position: absolute;
    z-index: 9;
  }

  .container {
    z-index: 11;
    width: 1150px;
    height: 429px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &>img {
      max-height: 429px;
    }

    .desc {
      position: relative;
      margin-left: 80px;
      height: 95%;

      .title {
        font-size: 28px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        text-align: left;
        color: #56a6ff;
        margin-bottom: 43px;
      }

      .name {
        font-size: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        margin-bottom: 25px;
      }

      .intro {
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #ffffff;
      }

      .vote-info {
        display: flex;
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 14px;
        color: $color-text-regular;

        .vote-check {
          width: 110px;
        }

        ::v-deep .el-checkbox__label {
          vertical-align: middle;
          color: #ffffff;
        }

        ::v-deep .el-checkbox__inner {
          width: 17px;
          height: 17px;
          border-color: $color-text-regular;

          &::after {
            left: 5.5px;
            top: 2.5px;
          }

          &:hover {
            border-color: #ffc15e;
          }
        }

        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #ffc15e;
          border-color: #ffc15e;
        }

        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #ffc15e;
        }

        .vote-num,
        .vote-look {
          height: 20px;
          width: 100px;

          svg {
            width: 24px;
            height: 21px;
            vertical-align: 0px;
            color: #ffffff;
          }

          span {
            color: #ffffff;
            margin-left: 8px;
            vertical-align: 6px;
          }

          .vote-icon {
            transform: translateY(-2px);
          }
        }
      }
    }
  }
}

.content-wrap {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;

  .item-wrap1 {
    margin: 0 7px 20px 7px;

    .max-height {
      max-height: 480px;
    }

    .item {
      width: 100%;
      height: 100%;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        transition: all ease-in-out 0.4s;
      }

      .mask {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(#000, 0.6);
        transition: all ease-in-out 0.4s;
        opacity: 0;

        .info {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transform: translateY(4%);
          transition: all ease-in-out 0.4s;
        }

        h2,
        h3 {
          color: #ffffff;
        }

        h2 {
          font-size: 16px;
        }

        h3 {
          margin-top: 4px;
          font-size: 14px;
        }
      }

      &:hover .mask {
        opacity: 1;
      }

      &:hover .info {
        transform: translateY(0);
      }

      &:hover>img {
        transform: scale(1.1);
      }
    }
  }

  .item-wrap2 {
    width: 382px;
    margin: 0 0px 25px 24px;

    &:nth-of-type(4n + 1) {
      margin-left: 7px;
    }

    .item {
      width: 382px;
      height: 248px;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        transition: all ease-in-out 0.4s;
      }

      .mask {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(#000, 0.6);
        transition: all ease-in-out 0.4s;
        opacity: 0;

        .info {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transform: translateY(4%);
          transition: all ease-in-out 0.4s;
        }

        h2,
        h3 {
          color: #ffffff;
        }

        h2 {
          font-size: 16px;
        }

        h3 {
          margin-top: 4px;
          font-size: 14px;
        }
      }

      &:hover .mask {
        opacity: 1;
      }

      &:hover .info {
        transform: translateY(0);
      }

      &:hover>img {
        transform: scale(1.1);
      }
    }

    .vote-info {
      display: flex;
      margin-top: 12px;
      font-size: 14px;
      color: $color-text-regular;

      .vote-check {
        width: 110px;
      }

      ::v-deep .el-checkbox__label {
        vertical-align: middle;
        color: $color-text-regular;
      }

      ::v-deep .el-checkbox__inner {
        width: 17px;
        height: 17px;
        border-color: $color-text-regular;

        &::after {
          left: 5.5px;
          top: 2.5px;
        }

        &:hover {
          border-color: #ffc15e;
        }
      }

      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #ffc15e;
        border-color: #ffc15e;
      }

      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #ffc15e;
      }

      .vote-num,
      .vote-look {
        height: 20px;
        width: 100px;

        svg {
          width: 24px;
          height: 21px;
          vertical-align: 0px;
        }

        span {
          color: $color-text-regular;
          margin-left: 8px;
          vertical-align: 6px;
        }
      }
    }
  }
}

.btn-wrap {
  margin: 90px 0;
  text-align: center;

  ::v-deep .el-button {
    height: 38px;
    font-size: 18px;
    padding: 10px 28px;
    color: $color-text-regular;
    border-color: $color-border-base;

    &:hover,
    &:active,
    &:visited,
    &:focus {
      background: none;
    }
  }

  ::v-deep .el-pager li.active {
    color: #ffc15e;
  }
}

.search-fail {
  margin: 50px auto;
  text-align: center;
  font-size: 24px;
  color: $color-text-primary;

  .guess-item1 {
    height: 100%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    margin-left: 7px;
    margin-top: 60px;
    margin-bottom: 300px;
    text-align: left;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: all ease-in-out 0.4s;
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(#000, 0.6);
      transition: all ease-in-out 0.4s;
      opacity: 0;

      .info {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: translateY(4%);
        transition: all ease-in-out 0.4s;
      }

      h2,
      h3 {
        color: #ffffff;
      }

      h2 {
        font-size: 16px;
      }

      h3 {
        margin-top: 4px;
        font-size: 14px;
      }
    }

    &:hover .mask {
      opacity: 1;
    }

    &:hover .info {
      transform: translateY(0);
    }

    &:hover>img {
      transform: scale(1.1);
    }
  }

  .guess-item2 {
    width: 382px;
    height: 248px;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    margin-left: 7px;
    margin-top: 60px;
    margin-bottom: 300px;
    text-align: left;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: all ease-in-out 0.4s;
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(#000, 0.6);
      transition: all ease-in-out 0.4s;
      opacity: 0;

      .info {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: translateY(4%);
        transition: all ease-in-out 0.4s;
      }

      h2,
      h3 {
        color: #ffffff;
      }

      h2 {
        font-size: 16px;
      }

      h3 {
        margin-top: 4px;
        font-size: 14px;
      }
    }

    &:hover .mask {
      opacity: 1;
    }

    &:hover .info {
      transform: translateY(0);
    }

    &:hover>img {
      transform: scale(1.1);
    }
  }
}
</style>